import Column from "@Containers/components/Column";
import VehicleAddonType from "@CheckOrder/types/VehicleAddon.type";
import useHandleJadrolinijaVehicleRemoval
    from "@CheckOrder/features/addons/features/jadrolinija/hooks/useHandleJadrolinijaVehicleRemoval";
import Translation from "@Translation/components/Translation";
import IconAddon from "@Icons/ticket/addons/IconAddon";
import EditTicketExtra from "@CheckOrder/components/EditTicketExtra";
import getSelectedVehicleIconData
    from "@CheckOrder/features/addons/features/jadrolinija/features/selectedVehicleAddon/functions/getSelectedVehicleIconData";
import VehicleAddonInfo
    from "@CheckOrder/features/addons/features/jadrolinija/features/selectedVehicleAddon/components/VehicleAddonInfo";

type VehicleAddonProps = {
    vehicle: VehicleAddonType,
    index: number,
}

function VehicleAddon({vehicle, index}: VehicleAddonProps) {
    const {removeVehicle} = useHandleJadrolinijaVehicleRemoval(vehicle)
    const {iconAddonProps} = getSelectedVehicleIconData(vehicle)

    // TODO implement this shit
    const editVehicleAddon = () => {
    }

    return (
        <Column className="check-order__passenger">
            <EditTicketExtra
                title={<Translation translationKey="check_order.addons.JADL.vehicle.title"/>}
                remove={removeVehicle}
            />
            <div className="ticket-addons__selected-list">
                <VehicleAddonInfo
                    vehicle={vehicle}
                />
                <IconAddon
                    {...iconAddonProps}
                    width="24"
                    height="24"
                    className="selected-addon__icon"
                />
                <div className="selected-addon__price">
                    {vehicle.price}
                </div>
            </div>
        </Column>
    );
}

export default VehicleAddon;